var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustryValueChain11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.829,
    height: 33.041,
    viewBox: "0 0 34.829 33.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -15.423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(24.339 21.81)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(16.879 21.81)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(20.953 24.237)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(20.953 19.658)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(13.917 24.237)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(13.917 19.658)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.221.406c0,.442-.54.8-1.2.8s-1.2-.357-1.2-.8.538-.8,1.2-.8,1.2.357,1.2.8",
    transform: "translate(10.068 22.321)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.887,9.047H-12.384a3.043,3.043,0,0,1-2.332-1.078,3.049,3.049,0,0,1-.674-2.5A17.326,17.326,0,0,1,1.751-8.79,17.324,17.324,0,0,1,18.89,5.465a3.045,3.045,0,0,1-3,3.582M1.751-7.641a16.171,16.171,0,0,0-16,13.305,1.9,1.9,0,0,0,.42,1.567,1.881,1.881,0,0,0,1.443.666H15.887a1.884,1.884,0,0,0,1.443-.666,1.908,1.908,0,0,0,.42-1.567,16.174,16.174,0,0,0-16-13.305",
    transform: "translate(15.437 24.213)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.982,3.218H-10.487A3.86,3.86,0,0,1-14.249.3l-.25-1a1.929,1.929,0,0,1,.361-1.672,1.963,1.963,0,0,1,1.548-.749H17.082a1.964,1.964,0,0,1,1.55.749,1.929,1.929,0,0,1,.361,1.672l-.25,1a3.86,3.86,0,0,1-3.762,2.922M-12.589-1.976a.812.812,0,0,0-.637.306.8.8,0,0,0-.148.688l.25,1a2.707,2.707,0,0,0,2.638,2.047H14.982A2.7,2.7,0,0,0,17.618.02l.25-1a.793.793,0,0,0-.148-.688.806.806,0,0,0-.637-.306Z",
    transform: "translate(14.94 45.245)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.272,2.763H-13.062A2.738,2.738,0,0,1-15.81.038a2.738,2.738,0,0,1,2.748-2.723H16.272A2.739,2.739,0,0,1,19.019.038a2.74,2.74,0,0,1-2.748,2.725m-29.334-4.3A1.584,1.584,0,0,0-14.651.038a1.583,1.583,0,0,0,1.589,1.575H16.272A1.583,1.583,0,0,0,17.858.038a1.584,1.584,0,0,0-1.587-1.575Z",
    transform: "translate(15.81 37.374)",
    fill: "#edaa30"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryValueChain11);
export default __webpack_public_path__ + "static/media/industry-value-chain-11.06aa410e93819a0b550784cdbadd3cf0.svg";
export { ForwardRef as ReactComponent };